import { MessageCircle } from "lucide-react";
import { BRAND } from "@/lib/data";

export default function WhatsAppFloat() {
  return (
    <a
      href={BRAND.whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-[99] group"
      aria-label="Chat on WhatsApp"
      data-testid="whatsapp-float-btn"
    >
      <span className="absolute inset-0 rounded-full bg-green-500 pulse-ring pointer-events-none" />
      <span className="relative flex items-center justify-center w-14 h-14 md:w-16 md:h-16 rounded-full bg-gradient-to-br from-green-500 to-green-600 shadow-[0_10px_30px_rgba(34,197,94,0.5)] hover:scale-110 transition-transform duration-300">
        <MessageCircle className="w-7 h-7 text-white" fill="white" />
      </span>
      <span className="absolute right-full mr-3 top-1/2 -translate-y-1/2 whitespace-nowrap bg-[#0A1229] border border-white/10 text-white text-xs font-medium px-3 py-2 rounded-full opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none">
        WhatsApp us — instant reply
      </span>
    </a>
  );
}
